import "./initHtmx";
import("preline/dist/preline.js");

import initWidgets from "./initWidgets";
import { initIframeManager } from "./iframeManager";
import { initCookieConsent } from "./cookieConsent";

async function loadTranslations(lang) {
  try {
    const translations = await import(`./translations/${lang}.json`);
    return translations.default;
  } catch {
    const translations = await import("./translations/sl.json");
    return translations.default;
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  const lang = document.documentElement.lang || "sl";
  const translations = await loadTranslations(lang);

  const im = initIframeManager(translations.iframeManager, lang);
  initCookieConsent(im, translations.cookieConsent, lang);
  initWidgets(document.body);
});
